// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"136":"events","681":"users","713":"risk-level","966":"dashboard","986":"regions"}[chunkId] || chunkId) + "." + {"118":"9343895e","136":"9c647740","518":"da62dcdc","596":"93739575","681":"8f484479","713":"401e9b5c","966":"c2c92e23","986":"5ed1cca5"}[chunkId] + ".js";
};